import { Component } from '@angular/core';

@Component({
  selector: 'itl-desktop-column',
  template: '<ng-content></ng-content>',
  styleUrls: ['./desktop-column.component.scss'],
  standalone: false,
})
export class DesktopColumnComponent {}
